export default __webpack_public_path__ + "static/media/slider-info-laptop-light-top.83937809.svg";